import { Stomp } from 'stompjs/lib/stomp';
import { SESSION_ID } from '../../config/session-id';
import { Module } from './module';

Module.service('WebSocket', WebSocket);

/** @ngInject */
function WebSocket($rootScope) {

    const {url, virtualHost, username, password} = window.env.websocket;
    let lastUsedAt = null;
    let client = null;
    let connecting = false;

    return {
        connect,
        isConnected,
        isConnecting,
    };

    function connect() {
        lastUsedAt = new Date();

        if (isConnected() || isConnecting()) {
            return;
        }

        client = Stomp.client(url);
        client.debug = null;
        connecting = true;
        client.connect(username, password, onConnect, onError, virtualHost);
    }

    function isConnected() {
        return client ? client.connected : false;
    }

    function isConnecting() {
        return connecting;
    }

    function onConnect(frame) {
        connecting = false;
        client.subscribe(`/exchange/websocket-exchange/${SESSION_ID}`, onReceive);
        $rootScope.$apply(() => $rootScope.$broadcast('websocket.connected'));
    }

    function onError(frame) {
        connecting = false;
        console.error(frame);
        $rootScope.$apply(() => $rootScope.$broadcast('websocket.disconnected'));
    }

    function onReceive(frame) {
        const {type, content} = JSON.parse(frame.body);
        $rootScope.$apply(() => $rootScope.$broadcast(`websocket.${type}`, content));
    }
}



// WEBPACK FOOTER //
// ./src/modules/reverse-ajax/web-socket.service.js